import { useCallback, useEffect, useRef } from "react";

import { create } from "zustand";

const hoverTextKeys = {
  noHover: "noHover",
  importManager: "importManager",
  dashboard: "dashboard",
  settings: "settings",
  help: "help",
  logout: "logout",
};

const useAccountAndSettingsStore = create((set) => ({
  hoverTextKey: hoverTextKeys.noHover,
  setHoverTextKey: (newText) => set({ hoverTextKey: newText }),
  timeoutRef: undefined,
  setTimeoutRef: (newRef) => set({ timeoutRef: newRef }),
}));

const useTimeoutRef = () => {
  const timeoutRef = useAccountAndSettingsStore((s) => s.timeoutRef);
  const setTimeoutRef = useAccountAndSettingsStore((s) => s.setTimeoutRef);
  const ref = useRef();

  useEffect(() => {
    setTimeoutRef(ref);
  }, [setTimeoutRef]);

  return [timeoutRef, setTimeoutRef];
};

const useHoverTextKey = () => {
  const hoverTextKey = useAccountAndSettingsStore((s) => s.hoverTextKey);
  const setHoverTextKeyRaw = useAccountAndSettingsStore(
    (s) => s.setHoverTextKey
  );
  const [timeoutRef = {}] = useTimeoutRef();

  const setHoverTextKey = useCallback(
    (newKey) => {
      clearTimeout(timeoutRef.current);
      if (newKey === hoverTextKeys.noHover) {
        timeoutRef.current = setTimeout(() => {
          setHoverTextKeyRaw(newKey);
        }, 150);
      } else setHoverTextKeyRaw(newKey);
    },
    [setHoverTextKeyRaw, timeoutRef]
  );

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, [timeoutRef]);

  return [hoverTextKey, setHoverTextKey];
};

export { useHoverTextKey, hoverTextKeys };
export default useAccountAndSettingsStore;
